import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { CSVLink } from 'react-csv';
import Wait4Me from '../Wait4Me';
import { Container, DownloadButton, DownloadIcon } from './styled';

class DownloadCSV extends Component {
  constructor(props) {
    super(props);
    this.state = {
      csvDownloadClicked: false,
      csvStateData: []
    };
  }

  //WARNING! To be deprecated in React v17. Use new lifecycle static getDerivedStateFromProps instead.
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps &&
      nextProps.csvData.length !== 0 &&
      this.state.csvDownloadClicked
    ) {
      this.setState(
        { csvStateData: nextProps.csvData, csvDownloadClicked: false },
        () => {
          if (!nextProps.disabled) {
            this.csvLink.link.click();
          }
        }
      );
    }
  }

  onCsvDownloadClick = async () => {
    if (this.props.disabled) return;

    this.setState({ csvDownloadClicked: true, csvStateData: [] });
    await this.props.onDownloadClick();
  };

  render() {
    const { csvDownloadClicked, csvStateData } = this.state;
    const { csvHeaders, fileName, disabled = false } = this.props;
    return (
      <Container>
        {!csvDownloadClicked && (
          <DownloadButton
            className={disabled && 'disabled'}
            onClick={this.onCsvDownloadClick}
          >
            <DownloadIcon
              className={classnames(
                'icon20',
                'icon20_icon_download',
              )}
            />
          </DownloadButton>
        )}
        {csvStateData.length === 0 && csvDownloadClicked && <Wait4Me />}
        <CSVLink
          data={csvStateData}
          headers={csvHeaders}
          filename={fileName}
          ref={(r) => (this.csvLink = r)}></CSVLink>
      </Container>
    );
  }
}

DownloadCSV.propTypes = {
  csvData: PropTypes.array,
  csvHeaders: PropTypes.array,
  fileName: PropTypes.string,
  onDownloadClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default DownloadCSV;
